import React from 'react';

const SmallStepIndicator = ({
  totalSteps,
  currentStep,
  className,
  setCurrentStep,
}) => {
  const stepsArray = Array.from({ length: totalSteps }, (_, i) => i + 1);
  return (
    <div className={`step-indicator-container ${className ?? ''}`}>
      {stepsArray.map((step) => (
        <div
          key={step}
          className='step-dot-container'
          onClick={() => setCurrentStep(step)}
        >
          <div
            className={`step-dot ${
              step === currentStep ? 'active-dot' : 'inactive-dot'
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default SmallStepIndicator;
